<template>
  <div class="header">
      <img src="../assets/tk-banner.png" style="width: 30rem" />
    <h1 class="h1">{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
 width: 100%; 
 text-align: 
 center; 
 padding-top: 3.5rem;
}

</style>
